import { render, staticRenderFns } from "./MyTemplatesFilters.vue?vue&type=template&id=de87a1c4&scoped=true"
import script from "./MyTemplatesFilters.vue?vue&type=script&lang=js"
export * from "./MyTemplatesFilters.vue?vue&type=script&lang=js"
import style0 from "./MyTemplatesFilters.vue?vue&type=style&index=0&id=de87a1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de87a1c4",
  null
  
)

export default component.exports